import { getBasePathRedirect } from './util/base-path';

// Imported first by the entry point so a URL outside the base path (such as
// the host root) moves to the application instead of rendering nothing.
const target = getBasePathRedirect(window.location, import.meta.env.BASE_URL);
if (target !== null) {
  window.location.replace(target);
}
